import { ReactNode, useLayoutEffect, useState } from "react";
import { useLocation } from "react-router";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { JSX } from "react";

const WorkspaceChecker = ({ children }: { children: ReactNode }) => {
  const user = useSelector((state: RootState) => state.user);
  const { pathname } = useLocation();

  const [hasPermission, setHasPermission] = useState(true);

  useLayoutEffect(() => {
    const isBlocked =
      pathname.includes("event") &&
      user?.workspace &&
      ["Registration Manager", "CheckIn Manager", "Branding Manager"].includes(
        user.workspace.role || ""
      );

    setHasPermission(!isBlocked);
  }, [pathname, user?.workspace?.role]);

  if (!hasPermission) return null;

  return children;
};

export default WorkspaceChecker;

export const WorkspaceCheckerHide = ({
  children,
  showFallback,
  showOnCompleted = false,
}: {
  children: JSX.Element;
  showFallback?: boolean;
  showOnCompleted?: boolean;
}) => {
  const role = useSelector((state: RootState) => state.user?.workspace?.role);
  const event = useSelector((state: RootState) => state.event);
  const isBlocked = [
    "Event Manager",
    "Registration Manager",
    "CheckIn Manager",
    "Branding Manager",
  ].includes(role || "");

  if (isBlocked) {
    return showFallback ? <>There is no event yet</> : null;
  }

  if (role === "Owner" || role === "Organizer") {
    return children;
  }

  // Other roles depend on event status and showOnCompleted flag
  if (event.status !== "archived" && event?.status !== "completed") {
    return children;
  }

  if (event.status !== "archived" && showOnCompleted) {
    return children;
  }

  return null;
};
